import { motion } from "framer-motion";
import { Check, LinkSimple } from "@phosphor-icons/react";
import { ResultCard } from "./ResultCard";

export function ChainResults({ chainResults, activeTab, setActiveTab, copiedChainIdx, onCopyChain, onReset }) {
  if (chainResults.length === 0) return null;

  return (
    <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} className="space-y-3" data-testid="chain-results">
      <div className="h-px bg-[var(--bg-hover)]" />

      {/* Tab bar */}
      <div className="flex gap-1 overflow-x-auto pb-1 scrollbar-thin">
        {chainResults.map((r, i) => (
          <button key={`chain-${r.target_type}`} onClick={() => setActiveTab(i)} data-testid={`chain-tab-${i}`}
            className={`shrink-0 px-3 py-2 rounded-md text-xs font-medium border transition-all ${
              activeTab === i
                ? "bg-[var(--accent-subtle)] border-[#FF4400] text-[#FF4400]"
                : r.error
                  ? "bg-red-500/5 border-red-400/30 text-red-400"
                  : "bg-[var(--bg-base)] border-[var(--border-strong)] text-[var(--text-muted)] hover:text-[var(--text-secondary)]"
            }`}>
            {r.target_type}
          </button>
        ))}
      </div>

      {/* Active tab content */}
      {chainResults[activeTab] && (
        chainResults[activeTab].error ? (
          <div className="border border-red-400/30 bg-red-500/5 rounded-md p-4" data-testid={`chain-result-${activeTab}`}>
            <p className="text-xs text-red-400">Failed: {chainResults[activeTab].error}</p>
          </div>
        ) : (
          <ResultCard
            result={chainResults[activeTab]}
            copied={copiedChainIdx === activeTab}
            onCopy={() => onCopyChain(chainResults[activeTab].repurposed_content, activeTab)}
            savedIndicator={true}
          />
        )
      )}

      <p className="text-xs text-[var(--success)] font-['JetBrains_Mono']" data-testid="chain-saved-indicator">
        All {chainResults.filter((r) => !r.error).length} result(s) saved to history
      </p>
      <button
        onClick={onReset}
        className="w-full py-2.5 rounded-md text-sm font-medium border border-[#FF4400]/30 text-[#FF4400] hover:bg-[#FF4400]/5 transition-colors flex items-center justify-center gap-2"
        data-testid="chain-another-btn"
      >
        <LinkSimple size={16} /> Chain to More Formats
      </button>
    </motion.div>
  );
}
